"use strict";

var _topbar$clientHeight;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var elements = document.querySelectorAll("[data-observable]");
var callback = function callback(entry, data, isIntersecting) {
  switch (data) {
    case "fade-up":
      {
        if (!isIntersecting) break;
        entry.classList.add("visible");
        break;
      }
    case "fade-up-scroll-only":
      {
        if (!entry.classList.contains("fade-up-view")) {
          if (!isIntersecting) {
            entry.classList.add("fade-up-view");
          } else {
            entry.classList.add("opacity-100", "visible");
          }
        } else {
          entry.classList.add("visible");
        }
        break;
      }
    case "lazy-img":
      {
        if (!isIntersecting) break;
        entry.setAttribute("src", entry.getAttribute("data-src"));
        break;
      }
    case "fade-left-scroll-only":
      {
        if (!entry.classList.contains("fade-left-view")) {
          if (!isIntersecting) {
            entry.classList.add("fade-left-view");
          } else {
            entry.classList.add("opacity-100", "visible");
          }
        } else {
          entry.classList.add("visible");
        }
        break;
      }
    case "fade-in-children":
      {
        var _parseInt;
        if (!isIntersecting) break;
        var delay = (_parseInt = parseInt(entry.getAttribute("delay"))) !== null && _parseInt !== void 0 ? _parseInt : 800;
        if (isNaN(delay) || typeof delay !== "number" || delay <= 0) {
          delay = 800;
        }
        Array.from(entry.children).forEach(function (child, i) {
          setTimeout(function () {
            child.classList.add("!opacity-100");
          }, delay * i + 300);
        });
        break;
      }
    case "count-up":
      {
        if (!isIntersecting) break;
        var _countUp = function countUp(entry) {
          if (typeof animateCountUp !== "undefined") {
            // eslint-disable-next-line no-undef
            animateCountUp(entry);
            return;
          }
          setTimeout(function () {
            return _countUp(entry);
          }, 1000);
        };
        _countUp(entry);
        break;
      }
    case "map":
      {
        if (!isIntersecting) break;
        if (!entry.hasAttribute("src")) {
          if (entry.parentElement.classList.contains("allowed")) {
            loadMap(entry);
          }
        }
        break;
      }
    case "recaptcha":
      {
        if (!isIntersecting) break;
        var modalElement = entry.closest("[modal]");
        if (modalElement) {
          var style = getComputedStyle(modalElement);
          if (style.display === "none" || style.opacity === "0" || style.visibility === "hidden") {
            console.debug("Modal is hidden, not loading reCAPTCHA");
            return;
          }
        }
        loadReCaptcha();
        break;
      }
    case "facebook":
      {
        if (!isIntersecting) break;
        loadFacebookScript();
        break;
      }
    default:
      {
        console.error("Unknown data-observable: ".concat(data));
        break;
      }
  }
};
var observer = new IntersectionObserver(handleIntersection);
elements.forEach(function (obs) {
  observer.observe(obs);
});
function handleIntersection(entries) {
  entries.forEach(function (entry) {
    callback(entry.target, entry.target.getAttribute("data-observable"), entry.isIntersecting);
  });
}

// eslint-disable-next-line no-unused-vars
var onScrollEvents = [];
var lastKnownScrollPosition = 0;
var ticking = false;
document.addEventListener("scroll", function () {
  lastKnownScrollPosition = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(function () {
      // eslint-disable-next-line no-undef
      settings.onScroll.forEach(function (e) {
        return e(lastKnownScrollPosition);
      });
      ticking = false;
    });
    ticking = true;
  }
});
var navbar = document.querySelector("nav");
var topbar = document.querySelector(".top-bar");
var positionTrigger = (_topbar$clientHeight = topbar === null || topbar === void 0 ? void 0 : topbar.clientHeight) !== null && _topbar$clientHeight !== void 0 ? _topbar$clientHeight : 0;
// eslint-disable-next-line no-undef
settings.onScroll.push(function (lastKnownScrollPosition) {
  navbar.classList[lastKnownScrollPosition > positionTrigger ? "add" : "remove"]("scrolled");
});
var openModal = function openModal(modal) {
  var _document$querySelect;
  (_document$querySelect = document.querySelector("[modal=".concat(modal, "]"))) === null || _document$querySelect === void 0 || _document$querySelect.classList.add("visible");
  loadReCaptcha();
};
document.querySelectorAll("[modal]").forEach(function (modal) {
  modal.addEventListener("click", function (e) {
    if (e.target.hasAttribute("modal")) {
      modal.classList.remove("visible");
    }
  });
});
function toggleMobileMenuJs(open) {
  document.body.classList[open ? "add" : "remove"]("menu-open");
}
document.querySelectorAll(".sub-menu").forEach(function (menu) {
  menu.setAttribute("height", menu.offsetHeight);
  menu.classList.add("max-h-0");
  if (menu.parentElement.classList.contains("open")) {
    menu.style.maxHeight = "".concat(menu.getAttribute("height"), "px");
  }
});
document.querySelectorAll("[menu]").forEach(function (chevron) {
  chevron.addEventListener("click", function () {
    var open = document.querySelector(".menu-".concat(chevron.getAttribute("menu"))).classList.contains("open");
    var submenu = document.querySelector(".sub-menu-".concat(chevron.getAttribute("menu")));
    if (open) {
      document.querySelector(".menu-".concat(chevron.getAttribute("menu"))).classList.remove("open");
      submenu.style.maxHeight = "0px";
    } else {
      document.querySelector(".menu-".concat(chevron.getAttribute("menu"))).classList.add("open");
      submenu.style.maxHeight = "".concat(submenu.getAttribute("height"), "px");
    }
  });
});
var reCaptchaLoaded = false;
function loadReCaptcha() {
  if (reCaptchaLoaded) {
    console.debug("reCAPTCHA already loaded");
    return;
  }
  console.debug("Loading reCAPTCHA");
  reCaptchaLoaded = true;
  var recaptchaScript = document.createElement("script");
  recaptchaScript.src = "https://www.google.com/recaptcha/api.js?render=" + settings.v3public;
  recaptchaScript.defer = true;
  if (typeof Bugsnag !== "undefined") {
    Bugsnag.leaveBreadcrumb("Loading reCAPTCHA script");
  }
  recaptchaScript.onload = function () {
    grecaptcha.ready(function () {
      if (typeof Bugsnag !== "undefined") {
        Bugsnag.leaveBreadcrumb("reCAPTCHA ready");
      }
      document.querySelectorAll("button.recaptcha").forEach(function (button) {
        button.disabled = false;
      });
    });
  };
  document.body.appendChild(recaptchaScript);
}
var facebookScriptLoaded = false;
function loadFacebookScript() {
  if (facebookScriptLoaded) return;
  facebookScriptLoaded = true;
  var facebookScript = document.createElement("script");
  facebookScript.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v13.0";
  facebookScript.defer = true;
  facebookScript.crossOrigin = "anonymous";
  document.body.appendChild(facebookScript);
}
var slideSelectors = document.querySelectorAll(".slide-selectors > div");
var selectSelector = function selectSelector(index) {
  slideSelectors.forEach(function (selector) {
    return selector.classList.remove("selected");
  });
  var slideSelector = document.querySelector(".slide-selector-".concat(index + 1));
  if (slideSelector) {
    slideSelector.classList.add("selected");
  }
};
var skipNextSlide = false;
var heroDelay = 3500;
function switchSlides(heroSlides) {
  heroSlides.forEach(function (slide, i) {
    setTimeout(function () {
      slide.classList.remove("opacity-0");
      selectSelector(i);
      setInterval(function () {
        selectSelector(i);
        heroSlides.forEach(function (slide) {
          return slide.classList.add("opacity-0");
        });
        slide.classList.remove("opacity-0");
      }, heroSlides.length * heroDelay);
    }, i * heroDelay);
  });
}
var heroContainers = _toConsumableArray(new Set(_toConsumableArray(document.querySelectorAll(".hero-slide")).map(function (slide) {
  return slide.parentElement;
})));

// Loop through each hero component and switch slides
heroContainers.forEach(function (heroContainer) {
  var heroSlides = heroContainer.querySelectorAll(".hero-slide");
  if (heroSlides.length > 1) {
    switchSlides(heroSlides);
  }
});
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function deleteCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
var scrollIntoViewById = function scrollIntoViewById(id) {
  var ids = id.split("||");
  var _iterator = _createForOfIteratorHelper(ids),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _id = _step.value;
      var element = document.querySelector("#".concat(_id));
      if (element) {
        element.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
        return;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  throw new Error("Element with id (".concat(ids.join(", "), ") not found"));
};
var loadMap = function loadMap(mapElement) {
  mapElement.src = !mapElement.getAttribute("x-src").startsWith("http") ? "https://google.com/" : mapElement.getAttribute("x-src");
};
var isElementInViewport = function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var mobileMenu = document.querySelector(".mobile-menu");
var links = mobileMenu.querySelectorAll("a");
links.forEach(function (link) {
  link.addEventListener("click", function (e) {
    if (["use", "svg"].includes(e.target.tagName.toLowerCase())) {
      e.preventDefault();
      var parent = e.target.parentElement.parentElement;
      parent.classList.toggle("open");
    }
  });
});
var scrollElement = document.querySelector("#scroll-top");
var offset = 200;
if (scrollElement) {
  var updateScrollPercentage = function updateScrollPercentage() {
    var getScrollPercentage = function getScrollPercentage() {
      var scrollTop = window.scrollY;
      var scrollHeight = document.documentElement.scrollHeight;
      var clientHeight = window.innerHeight;
      var totalScrollableHeight = scrollHeight - clientHeight;
      if (totalScrollableHeight === 0) return 100; // In case the document is not scrollable

      var scrollPercentage = scrollTop / totalScrollableHeight * 100;
      return scrollPercentage;
    };
    var scrollTop = window.scrollY;
    var progress = getScrollPercentage();
    scrollElement.classList[scrollTop >= offset ? "add" : "remove"]("active");
    scrollElement.style.background = "conic-gradient(var(--color-scheme) 0% ".concat(progress, "%, transparent ").concat(progress, "% 100%)");
  };
  settings.onScroll.push(updateScrollPercentage);
  updateScrollPercentage();
  scrollElement.addEventListener("click", function (event) {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
}
var modals = document.querySelectorAll("[modal]");
modals.forEach(function (modal) {
  var modalId = modal.getAttribute("modal");
  var closeButton = modal.querySelector('[data-action="close"]');
  if (!closeButton) {
    console.error("Modal ID: ".concat(modalId, " is missing a close button"));
    return;
  }
  closeButton.addEventListener("click", function () {
    modal.classList.remove("visible");
  });
});
var animationDuration = 3000;
var frameDuration = 1000 / 60;
var totalFrames = Math.round(animationDuration / frameDuration);
var easeOutQuad = function easeOutQuad(t) {
  return t * (2 - t);
};

// eslint-disable-next-line no-unused-vars
var animateCountUp = function animateCountUp(el) {
  var frame = 0;
  var countTo = parseInt(el.getAttribute("target"), 10);
  var currentValue = parseInt(el.innerHTML);
  if (currentValue > 0) {
    return;
  }
  var counter = setInterval(function () {
    frame++;
    var progress = easeOutQuad(frame / totalFrames);
    var currentCount = Math.round(countTo * progress);
    if (parseInt(el.innerHTML, 10) !== currentCount) {
      el.innerHTML = currentCount;
    }
    if (frame === totalFrames) {
      clearInterval(counter);
    }
  }, frameDuration);
};
var toggles = document.querySelectorAll(".menu-toggle");
toggles.forEach(function (toggle) {
  toggle.addEventListener("click", function (event) {
    var parentItem = toggle.closest(".menu-item");
    var expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", !expanded);
    parentItem.classList.toggle("expanded", !expanded);
  });
});
//# sourceMappingURL=index.js.map